import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnChanges, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DxPopupModule } from 'devextreme-angular';

const MOBILE_MAX_WIDTH = 576;

/**
 * Shows an uploaded document (image or PDF) in a popup over the page, so users
 * view what they sent without being sent off to a browser tab they then have to
 * find their way back from — on a phone especially.
 */
@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss'],
})
export class FileViewerComponent implements OnChanges {
  @Input() url: string | null = null;
  @Input() name: string | null = null;
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  kind: 'image' | 'pdf' | 'other' = 'other';
  frameUrl: SafeResourceUrl | null = null;
  isMobile = false;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    this.isMobile = window.innerWidth < MOBILE_MAX_WIDTH;
    const path = (this.url ?? '').split('?')[0].toLowerCase();
    this.kind = /\.(png|jpe?g|gif|webp)$/.test(path) ? 'image' : path.endsWith('.pdf') ? 'pdf' : 'other';
    // The URL is our own stored document, from the API.
    this.frameUrl = this.kind === 'pdf' && this.url ? this.sanitizer.bypassSecurityTrustResourceUrl(this.url) : null;
  }

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}

@NgModule({
  imports: [CommonModule, DxPopupModule],
  declarations: [FileViewerComponent],
  exports: [FileViewerComponent],
})
export class FileViewerModule {}
